import { FormControl, FormLabel, Button, SxProps, Box, Typography, ToggleButtonGroup, ToggleButton } from "@mui/material";
import { mobiliTheme } from "../../../themes/mobiliTheme";
import { InfoOutlined } from "@mui/icons-material";
import { useState, useEffect } from "react";

interface PatientAvailabilityToggleProps {
  value?: string;
  onChange: (value: string) => void;
  sx?: SxProps;
  disabled?: boolean;
}

const PatientAvailabilityToggle: React.FC<PatientAvailabilityToggleProps> = ({ value, onChange, sx, disabled = false }) => {
  const [mode, setMode] = useState(value || "Nicht verfügbar");

  useEffect(() => {
    if (value) {
      setMode(value);
    }
  }, [value]);

  const handleChange = (event: React.MouseEvent<HTMLElement>, newMode: string) => {
    if (newMode !== null) {
      setMode(newMode);
      onChange(newMode);
    }
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'flex-start', ...sx }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <FormLabel sx={{ fontSize: 11, fontWeight: 600, color: "#666", margin: 0 }}>Zeiträume markieren als:</FormLabel>
        <ToggleButtonGroup value={mode} onChange={handleChange} exclusive disabled={disabled}>
          <ToggleButton
            value="Nicht verfügbar"
            sx={{
              textTransform: "none",
              fontSize: 11,
              m: 0,
              p: 0.5,
              // color: mobiliTheme.palette.error.main,
              '&.Mui-selected': {
                color: '#fff',
                backgroundColor: mobiliTheme.palette.error.light,
                '&:hover': {
                  backgroundColor: mobiliTheme.palette.error.dark,
                },
              },
            }}
          >
            Nicht verfügbar
          </ToggleButton>
          <ToggleButton
            value="Verfügbar"
            sx={{
              textTransform: "none",
              fontSize: 11,
              m: 0,
              p: 0.5,
              // color: mobiliTheme.palette.success.main,
              '&.Mui-selected': {
                color: '#fff',
                backgroundColor: mobiliTheme.palette.success.light,
                '&:hover': {
                  backgroundColor: mobiliTheme.palette.success.dark,
                },
              },
            }}
          >
            Verfügbar
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      <Typography variant="caption" sx={{ fontSize: 10, fontStyle: 'italic', color: '#666', minHeight: '1.2em' }}>
        <InfoOutlined sx={{ fontSize: 14, margin: 0, padding: 0, verticalAlign: 'text-bottom' }} />{' '}
        {mode === "Verfügbar"
          ? 'Diese Zeiträume werden als Verfügbarkeit eingegeben, beim Speichern in Unverfügbarkeiten umgewandelt und so angezeigt.'
          : 'Diese Zeiträume werden als Unverfügbarkeit gespeichert und so angezeigt.'
        }
      </Typography>
    </Box>
  );
};

export default PatientAvailabilityToggle;
